import type { AutoSuggestedWork, Sync, UserAccount, UserProfile } from "@/api/queries";

import type { SyncsApplyFormData } from "./syncsApplySchema";

export type SyncApiPayload = {
  type: "sync";
  songs: string;
  content: string;
  opportunity: string;
  username: string;
  email: string;
  artist: string;
};

export function buildSyncPayload(
  data: SyncsApplyFormData,
  cachedSongs: AutoSuggestedWork[],
  syncsData: Sync[],
  myAccount: UserAccount | undefined,
  userInfo: UserProfile | undefined,
): SyncApiPayload {
  const selectedSongs = data.songList.map((song) => {
    const cached = cachedSongs.find(c => c.workcode === song.workcode);
    return {
      workcode: song.workcode,
      title: song.title.trim().length > 0 ? song.title : (cached?.title ?? ""),
    };
  });

  const opportunity = syncsData.find(
    sync => Number.parseInt(sync._id) === Number.parseInt(data.opp),
  )?.name ?? "";

  return {
    type: "sync",
    songs: JSON.stringify(selectedSongs),
    content: data.content ?? "",
    opportunity,
    username: userInfo?.username != null ? String(userInfo.username) : "",
    email: userInfo?.email ?? "",
    artist: myAccount?.accountname ?? "",
  };
}
